import { Box, Stack, Typography } from '@mui/material';

interface SubscribeDrawerHeaderProps {
  title: string;
}

const SubscribeDrawerHeader = ({ title }: SubscribeDrawerHeaderProps) => {
  return (
    <Box
      sx={{
        py: 2,
        px: 4,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">{title}</Typography>
      </Stack>
    </Box>
  );
};

export default SubscribeDrawerHeader;
